module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('v-map', {
    staticStyle: {
      "height": "40em"
    },
    attrs: {
      "zoom": _vm.zoom,
      "center": _vm.center
    }
  }, [_c('v-tilelayer', {
    attrs: {
      "url": _vm.url,
      "attribution": _vm.attribution
    }
  }), _vm._v(" "), _vm._l((_vm.markers), function(item) {
    return _c('v-marker', {
      key: item.name,
      attrs: {
        "lat-lng": item.position,
        "icon": item.icon
      }
    }, [_c('v-popup', {
      attrs: {
        "content": item.popup
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.lines), function(item) {
    return _c('v-polyline', {
      key: item.name,
      attrs: {
        "lat-lngs": item.position,
        "color": item.color
      }
    })
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h2', [_vm._v("Settings")]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.widerangeOnly),
      expression: "settings.widerangeOnly"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.widerangeOnly) ? _vm._i(_vm.settings.widerangeOnly, null) > -1 : (_vm.settings.widerangeOnly)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settings.widerangeOnly,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.settings.widerangeOnly = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.settings.widerangeOnly = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settings.widerangeOnly = $$c
        }
      }
    }
  }), _vm._v(" Show Widerange-transmitter only")]), _c('br'), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.showNodes),
      expression: "settings.showNodes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.showNodes) ? _vm._i(_vm.settings.showNodes, null) > -1 : (_vm.settings.showNodes)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settings.showNodes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.settings.showNodes = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.settings.showNodes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settings.showNodes = $$c
        }
      }
    }
  }), _vm._v(" Show nodes")]), _c('br'), _vm._v(" "), (_vm.settings.showNodes) ? _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.showLines),
      expression: "settings.showLines"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.showLines) ? _vm._i(_vm.settings.showLines, null) > -1 : (_vm.settings.showLines)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settings.showLines,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.settings.showLines = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.settings.showLines = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settings.showLines = $$c
        }
      }
    }
  }), _vm._v(" Show line from transmitter to node")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Map")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f0ce679"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/transmitter/Map.vue
// module id = 609
// module chunks = 1